import { schema } from "normalizr";

export const socialAccount = new schema.Entity("socialAccounts");
export const socialAccountList = new schema.Array(socialAccount);

export const publisherOffer = new schema.Entity("publisherOffers");
export const publisherOfferList = new schema.Array(publisherOffer);
